import BrandListIntegrationStatus from './BrandListIntegrationStatus';

export default BrandListIntegrationStatus;
